<script>
   /*************************************************************/
   /* PrepInfo                                                  */
   /* -------------------------                                 */
   /* shows information about preprocessing model               */
   /*************************************************************/

   import { methodsList } from '@mdatools-apps/wasm/prep.js';

   let { prepmodel } = $props();
</script>


{#if prepmodel.ml}
<span class="info-details">
   {prepmodel.ml.length + ' method'  + (prepmodel.ml.length > 1 ? 's' : '') }
   <!-- the descriptions come from a model file, so they are rendered as text, not as markup -->
   <span>
      <ul>
         {#each prepmodel.ml as m, i}
         <li>{methodsList[m].title} <span>{prepmodel.info[i]}</span></li>
         {/each}
      </ul>
   </span>
</span>
{:else}
skipped
{/if}


<style>

   .info-details {
      position: relative;
      border-bottom: dashed 1px  #606060;
      cursor:help;
   }

   .info-details > span {
      visibility: hidden;
      position: absolute;
      z-index: 1;
      background: #505050;
      width: 300px;
      top: 100%;
      left: 50%;
      margin-left: -100px;
      color: beige;
      box-shadow: 0px 0 5px #00000060;
      padding: 0.5em 1em;
      border-radius: 0.25em;
   }

   .info-details > span > ul {
      padding: 0;
      margin: 0;
      list-style: none;
   }

   .info-details > span > ul > li {
      padding: 0.25em 0;
   }

   .info-details > span > ul > li > span {
      margin-left: 1em;
      padding: 0.15em 0.5em;
      background-color: #707070;
      border-radius: 3px;
   }

   .info-details:hover > span{
      visibility: visible;
   }
</style>